import throttle from 'lodash/throttle';
import { Component, type JSX, PureComponent } from 'react';

export const calculateChange = (e, hsl, container) => {
  const {
    width: containerWidth,
    height: containerHeight,
    left: containerLeft,
    top: containerTop,
  } = container.getBoundingClientRect();
  const x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  const y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  let left = x - (containerLeft + window.pageXOffset);
  let top = y - (containerTop + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  const saturation = left / containerWidth;
  const bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv',
  };
};

type SaturationProps = {
  hsl: {
    h: number;
    s: number;
    l: number;
    a: number;
  };
  hsv: {
    h: number;
    s: number;
    v: number;
    a: number;
  };
  pointer?: JSX.Element;
  onChange: () => void;
};

export class Saturation extends (PureComponent || Component)<SaturationProps> {
  private throttle: any;
  private container: any;

  constructor(props: SaturationProps) {
    console.log('HI!', props);
    super(props);

    this.throttle = throttle((fn, data, e) => {
      fn(data, e);
    }, 50);
  }

  componentWillUnmount() {
    this.throttle.cancel();
    this.unbindEventListeners();
  }

  handleChange = (e) => {
    typeof this.props.onChange === 'function' &&
      this.throttle(
        this.props.onChange,
        calculateChange(e, this.props.hsl, this.container),
        e
      );
  };

  handleMouseDown = (e) => {
    this.handleChange(e);
    e.target.ownerDocument.addEventListener('mousemove', this.handleChange);
    e.target.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
  };

  handleMouseUp = (e) => {
    this.unbindEventListeners(e);
  };

  unbindEventListeners(e?: any) {
    e?.target.ownerDocument?.removeEventListener(
      'mousemove',
      this.handleChange
    );
    e?.target.ownerDocument?.removeEventListener('mouseup', this.handleMouseUp);
  }

  render() {
    return (
      <div
        style={{
          inset: '0px',
          position: 'absolute',
          background: `hsl(${this.props.hsl.h},100%, 50%)`,
        }}
        ref={(container) => (this.container = container)}
        onMouseDown={this.handleMouseDown}
        onTouchMove={this.handleChange}
        onTouchStart={this.handleChange}
      >
        <style>{`
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `}</style>
        <div
          className="saturation-white"
          style={{
            inset: '0px',
            position: 'absolute',
          }}
        >
          <div
            className="saturation-black"
            style={{
              inset: '0px',
              position: 'absolute',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: `${-(this.props.hsv.v * 100) + 100}%`,
              left: `${this.props.hsv.s * 100}%`,
              cursor: 'default',
            }}
          >
            {this.props.pointer ? (
              // @ts-ignore
              <this.props.pointer {...this.props} />
            ) : (
              <div
                style={{
                  width: '4px',
                  height: '4px',
                  boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
                0 0 1px 2px rgba(0,0,0,.4)`,
                  borderRadius: '50%',
                  cursor: 'hand',
                  transform: 'translate(-2px, -2px)',
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Saturation;
